<template>
    <div @click="$emit('transition-front')">
        <v-img
            class="kk-card"
            :src="
                $vuetify.breakpoint.smAndDown
                    ? require('@/assets/card/back-xs.png')
                    : require('@/assets/card/back-md.png')
            "
            cover
        >
        </v-img>
    </div>
</template>

<script>
export default {
    name: 'card-back',
};
</script>

<style lang="scss" scoped>
.kk-card {
    height: 300px;
    width: 300px;
    @include break('sm') {
        width: 500px;
    }
    @include break('md') {
        width: 380px;
        height: 562px;
    }
}
</style>
